import React from "react";
const MyFoodsPageDispatchContext = React.createContext();
const MyFoodsPageDispatchProvider = MyFoodsPageDispatchContext.Provider;

export { MyFoodsPageDispatchContext, MyFoodsPageDispatchProvider };
